import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {
  Box,
  Grid,
  Typography,
  Button,
  Paper,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import useErrorHandler from "../../hooks/useErrorHandler";
import {
  getDynamicViewDataList,
  getPageNameData,
  getSectionNameData,
} from "../../api/dynamic-view";
import { SalesOrdheaderTable } from "../../config/reactfile.js";
import { useParams } from "react-router-dom";

export default function ItemDetail() {
  const [pageName, setPageName] = useState("Journal");
  const [sectionName, setSectionName] = useState("lines");
  const dispatch = useDispatch();
  const errorHandler = useErrorHandler();
  const [anchorEl, setAnchorEl] = useState(null);
  const open1 = Boolean(anchorEl);
  const snackbar = useSnackbar();
  const params = useParams();
  const { data: user } = useSelector((state) => state.user);
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  const [pageNameListData, setPageNameDataList] = useState([]);
  const [sectionNameListData, setsectionNameDataList] = useState([]);
  console.log("params---", params.id);
  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }

  //get table data//
  async function getdynamicViewData(limit, offset) {
    try {
      const combineData = { page_name: pageName, sec_name: sectionName };
      const apiParams = { limit, offset };

      if (params.id) {
        apiParams.transid = params.id;
      }
      const { data } = await getDynamicViewDataList(
        user?.token,
        combineData,
        apiParams
      );
      return {
        rows: data.data.data,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false)
    }
  }
  async function getPageNameList() {
    try {
      const { data } = await getPageNameData(user.token, {});
      setPageNameDataList(data.data.pageList);
    } catch (error) {
      errorHandler(error);
    } finally {
      // setLoading(false)
    }
  }
  async function getSectionNameList() {
    try {
      const { data } = await getSectionNameData(user.token, {});
      setsectionNameDataList(data.data.sectionList);
    } catch (error) {
      errorHandler(error);
    } finally {
      // setLoading(false)
    }
  }
  useEffect(() => {
    getPageNameList();
    getSectionNameList();
  }, []);
  // useEffect(() => {
  //   getSectionNameList();
  // }, [pageName]);
  useEffect(() => {
    refreshTable();
  }, [pageName, sectionName]);
  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        pb={2}
      >
        <Typography component="h5" fontWeight={500} className="pageHeading1">
          journal item detail
        </Typography>
        <Button
          className="backBtn"
          onClick={() => {
            window.location.reload(); // Perform hard refresh after API call
          }}
        >
          Get latest column names
        </Button>
      </Box>

      {/* <Box component={Paper} p={2}>
        <Grid container spacing={2}>
          <Grid item md={3} sm={6} xs={12}>
            <FormControl fullWidth>
              <InputLabel id="page-name-label">Page Name</InputLabel>
              <Select
                labelId="page-name-label"
                id="page-name-select"
                value={pageName}
                label="Page Name"
                onChange={(e) => setPageName(e.target.value)}
              >
                {pageNameListData.map((item, i) => {
                  return (
                    <MenuItem value={item.pagename}>{item.pagename}</MenuItem>
                  );
                })}
       
              </Select>
            </FormControl>
          </Grid>

          <Grid item md={3} sm={6} xs={12}>
            <FormControl fullWidth>
              <InputLabel id="section-name-label">Section Name</InputLabel>
              <Select
                labelId="section-name-label"
                id="section-name-select"
                value={sectionName}
                label="Section Name"
                onChange={(e) => setSectionName(e.target.value)}
              >
                {sectionNameListData.map((item, i) => {
                  return (
                    <MenuItem value={item.sec_name}>{item.sec_name}</MenuItem>
                  );
                })}
           
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box> */}
      <br />
      <Paper elevation={3}>
        <AgGridPaginatedTable
          getTableRows={getdynamicViewData}
          columns={SalesOrdheaderTable}
          perPage={10}
          refreshCounter={tableRefreshCount}
        />
      </Paper>
    </>
  );
}
function addAdditionalColumn(obj, dispatch) {
  if (obj === undefined) {
    SalesOrdheaderTable.unshift({
      headerName: "Action",
      field: "actions",
      maxWidth: 86,
      cellRendererFramework: (params) => (
        <Box>
          <Button
            className="actionIcon"
            onClick={() => {
              dispatch({ type: "DIALOG", data: params.data });
            }}
          >
            <EditOutlinedIcon />
          </Button>
        </Box>
      ),
    });
  }
}
